define('companiesDetailHeaderView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'buttonView',
  'template!companiesDetailHeaderView'
], function (
  App,
  Module,
  Marionette,
  _,
  ButtonView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'companies-detail-header-view',

    ui: {
      name: '.name',
      nameInput: '.name-input',
      editName: '.edit-name'
    },

    events: {
      'click @ui.editName': 'onEditName',
      'keydown @ui.nameInput': 'onNameKeydown',
      'blur @ui.nameInput': 'onNameBlur'
    },

    modelEvents: {
      'change:name': 'render',
      'change:emailDomain': 'render',
      'change:vatNumber': 'render'
    },

    regions: {
      backRegion: '.back-region'
    },

    onRender: function () {
      // Re-created on every render (editing the name re-renders the header).
      this.backButtonView = new ButtonView({
        type: 'list',
        text: _.i18n('common.back.to.list'),
        title: _.i18n('common.back.to.list')
      });
      this.getRegion('backRegion').show(this.backButtonView);
      this.backButtonView.on('click', _.bind(this.onBackList, this));
    },

    onEditName: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.editing = true;
      this.cancelEdit = false;
      this.ui.name.hide();
      this.ui.editName.hide();
      this.ui.nameInput.val(this.model.get('name') || '').css('display', 'inline-block').focus().select();
    },

    onNameKeydown: function (e) {
      if (e.which === 13) { // Enter -> save (through blur)
        e.preventDefault();
        this.ui.nameInput.blur();
      } else if (e.which === 27) { // Escape -> cancel
        e.preventDefault();
        this.cancelEdit = true;
        this.ui.nameInput.blur();
      }
    },

    onNameBlur: function () {
      if (!this.editing) {
        return;
      }
      this.editing = false;

      if (this.cancelEdit) {
        this.cancelEdit = false;
        this.render();
        return;
      }

      var value = (this.ui.nameInput.val() || '').trim();
      if (!value || value === this.model.get('name')) {
        this.render();
        return;
      }

      // On success the server returns the updated company -> change:name -> render.
      this.model.save({ name: value }, { wait: true })
        .fail(_.bind(function () {
          this.render();
        }, this));
    },

    onBackList: function () {
      App.navigate('companies', {trigger: true});
    }
  });
});

